//Libraries
import React, { useEffect } from "react";
import { UserProvider } from "@auth0/nextjs-auth0";
import Head from "next/head";
import NextNProgress from "nextjs-progressbar";

//Styles
import "tailwindcss/tailwind.css";
import "../styles/globals.css";

//Components
import Toast from "../components/Toast/Toast";

//Side-effect: installs the client-side axios interceptor that attaches the
//Auth0 Bearer token to AW_API_HOST requests (see services/awAuth.js).
import "../services/awAuth";

export default function App({ Component, pageProps }) {
  const env = process.env.NEXT_ENV;

  useEffect(() => {
    const mp_script = document.createElement("script");
    mp_script.src = "https://sdk.mercadopago.com/js/v2";
    mp_script.async = true;
    document.body.appendChild(mp_script);
  }, []);

  return (
    <UserProvider>
      <Head>
        <title>Among Wings</title>
        <meta name="description" content="Where Art Meets your Senses" />
        <link rel="icon" href="/favicon.ico" />
        {env !== "production" && <meta name="robots" content="none"></meta>}
      </Head>
      <NextNProgress color="#e01818" startPosition={0.6} stopDelayMs={1000} />
      <Component {...pageProps} />

      {/* Toast */}
      <Toast />
    </UserProvider>
  );
}
